'use client'
import { motion } from 'motion/react'
import React, { useState } from 'react'
import { useSlate } from 'slate-react'
import { addNode, removeElement } from '../services/node'
import { LinkDialog, LinkForm } from './dialog'
import { isBlockActive } from '../funcitons'
import { VideoIcon } from '@radix-ui/react-icons'

export function LinkMark({
  dialogTitle,
  className,
  children,
  format,
}: {
  dialogTitle: string
  format: string
  className?: string
  children?: React.ReactNode
}) {
  const [open, setOpen] = useState(false)
  const editor = useSlate()
  const [isActive, node] = isBlockActive(editor, format)

  const onConfirmValue = (value: LinkForm) => {
    addNode(editor, { type: format, text: '', url: value.link })
    setOpen(false)
  }

  const onRemoveButton = () => {
    removeElement(editor, format)
    setOpen(false)
  }

  return (
    <LinkDialog
      title={dialogTitle}
      open={open}
      value={isActive && node ? node?.url : undefined}
      onOpenChange={setOpen}
      onConfirmValue={onConfirmValue}
      onRemoveButton={node !== false ? onRemoveButton : undefined}>
      <motion.button
        type="button"
        whileTap={{ scale: 0.95 }}
        className={`toolbar-button ${isActive ? 'active' : ''} ${className ? ` ${className}` : ''}`}>
        {children || <VideoIcon />}
      </motion.button>
    </LinkDialog>
  )
}
